export default "__VITE_ASSET__75e586db__"